// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xi1D","icon":"styles_icon__3yhqS"};